// ..\app\pages\companiesHouse\pageFunctions\checkboxFunctions.js
import React from 'react';
import { withStyles } from '@mui/styles'
import Checkbox from '@mui/material/Checkbox'
import { COLOR, KEY_VALUES, LSE_INDEX_ENUM } from "../../../modules/constants"
import { CHECKBOX } from "../../../modules/checkbox_constants"
import HOOK from "../../../components/hooks"

// Trial users are locked to the FTSE 100 constituent only within the LSE Group selector
const isLockedLseIndexBit = ({ bit, features, hook }) =>
  hook === HOOK.LSE_INDEX && !!features?.Trial && bit !== CHECKBOX[HOOK.LSE_INDEX][LSE_INDEX_ENUM.FTSE_100].BIT

export const CustomCheckbox = withStyles({
  root: {
    color: COLOR.BAD,
    "&$checked": {
      color: COLOR.BAD
    }
  },
})((props) => <Checkbox {...props} />)

export const createCheckbox = props => {
  // console.log('createCheckbox props:', props)
  // NB: checkbox is CHECKBOX[hook][x]
  const { checkbox, checkboxes, color, enabled, handleChangeCheckbox, handleNotSubscribed, hook, labelColor, portrait, tooltipTitle } = props

  return {
    bit: checkbox.BIT,
    count: checkbox.COUNT,
    checked: !!(checkbox.BIT & checkboxes[hook]),
    tooltipTitle: tooltipTitle ?? checkbox.TOOLTIP_TITLE, // previously `show ${checkbox.NAME} ${checkbox.SUFFIX}`
    label: checkbox.NAME,
    handleChange: enabled ? handleChangeCheckbox : handleNotSubscribed,
    portrait: portrait,
    opacity: enabled ? "100%" : KEY_VALUES.DISABLED_OPACITY,
    color,
    labelColor: labelColor || "black",
    enabled,
    hook,
  }
}

// Checks or unchecks all the checkboxes in 'hooks'
export const setAllCheckboxes = props => {
  // console.log('props:', props)
  const checkboxes = JSON.parse(JSON.stringify(props.checkboxes))
  props.hooks.forEach(hook => {
    checkboxes[hook] = props.checked
      ? Math.pow(2, Object.keys(CHECKBOX[hook]).length) - 1
      : 0

    // Trial users are locked to the FTSE 100 constituent only within the LSE Group selector
    if (hook === HOOK.LSE_INDEX && !!props.features?.Trial)
      checkboxes[hook] = checkboxes[hook] & CHECKBOX[HOOK.LSE_INDEX][LSE_INDEX_ENUM.FTSE_100].BIT
  })

  if (props.isLoggedIn)
    props.common.saveCheckboxes(checkboxes)

  props.common.historyPush({ ...props, checkboxes })
}

// Gets an bool array of the current setting of the checkboxes supplied
export const getChecked = ({ checkboxes, hook }) =>
  CHECKBOX[hook].map(element => {
    return !!(element.BIT & checkboxes[hook])
  })

// Returns max value for the specified checkbox ie when all are set
// Eg LSE_INDEX (FTSE 100, FTSE 250, FTSE SmallCap, AIM All-Share, Other LSE) is 31
export const getMax = hook => Math.pow(2, Object.keys(CHECKBOX[hook]).length) - 1

export const changeCheckbox = props => {
  // console.log('changeCheckbox props:', props)
  const { hook } = props

  if (isLockedLseIndexBit(props))
    return

  const checkboxes = JSON.parse(JSON.stringify(props.checkboxes))
  // Flip (XOR) the relevant checkboxes bit
  props.previousCheckboxes[hook] = checkboxes[hook]
  checkboxes[hook] = checkboxes[hook] ^ props.bit // XOR

  if (props.isLoggedIn)
    props.common.saveCheckboxes(checkboxes)

  props.common.historyPush({ ...props, checkboxes })
}

